// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DealsService } from '@services/deals.service';

@Component({
    selector: 'app-deal-root',
    templateUrl: './deal-root.component.html',
    styles: [
        `
            .router-container {
                height: 100%;
            }
        `,
    ],
})
export class DealRootComponent {
    constructor(
        private readonly activatedRoute: ActivatedRoute,
        private readonly dealsService: DealsService
    ) {
        this.activatedRoute.params.subscribe((params) => {
            this.dealsService.selectedDealId = +params.dealId;
        });
    }
}
